export default __webpack_public_path__ + "static/media/notif-pr.cdecd732.svg";